import type { CommonProps } from '../../types';
import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { CheckboxSlider, Heading, Text } from '../../';
import { ReactElement } from 'react';

export interface CheckboxGroupProps
    extends CommonProps,
        VariantProps<typeof CheckboxGroupStyles> {
    children: ReactElement<typeof CheckboxSlider>[];
    title?: string | null;
    subTitle?: string | null;
}

export const CheckboxGroupStyles = cva('w-full mb-4');

export const CheckboxGroup = ({
    className,
    children,
    title,
    subTitle,
    testId = 'checkbox-group',
}: CheckboxGroupProps): JSX.Element => {
    return (
        <fieldset
            data-testid={testId}
            className={twMerge(CheckboxGroupStyles({ className }))}
        >
            <legend className="sr-only">{title}</legend>
            <Heading size="h4" className="mr-4 pl-6 font-semibold">
                {title}
            </Heading>
            <Text size="sm">{subTitle}</Text>
            <div className="mt-4 rounded-md border border-white px-4 py-9 md:px-12">
                {children}
            </div>
        </fieldset>
    );
};
